
import { Profile, WebchatSettings, Setting } from '@tactful/sdk';
import Vue from 'vue';
import bugsnagClient from "@/utilities/bugsnag";

export interface ProfileState {
    settings: Setting;
    current_profile: Profile;
    profile_name: string;
    channelSettings: WebchatSettings
}

export const profile = {
    state: Vue.observable<ProfileState>({
        settings: {},
        current_profile: null,
        profile_name: '',
        channelSettings: {}
    }),
    async loadProfile(profileId: number) {
        await this.getSettings(profileId);
        // await this.getWebchatSettings(profileId, channelId);
    },
    async getSettings(_profile_id: number) {
        try { 
            //@ts-ignore
            // eslint-disable-next-line no-undef
            this.state.settings = profileSettings;
        } catch (error) {
            console.log("getSettings", error);
            bugsnagClient.notify(error as any);
        }
    },
    async getWebchatSettings(_profile_id: number, channelId: number) {
        try { //@ts-ignore
            console.log("channelId :", channelId);
            //@ts-ignore
            this.state.channelSettings = webchatSettingsStatic;
        } catch (error) {
            console.log("getWebchatSettings", error);
            bugsnagClient.notify(error as any);
        }
    },

};

